import React from 'react';

import { isLoggedInUserEngineer } from '@paragon/login-tools';

import { useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function GussetsContainerMenu() {
  const userIsEngineer = useAppSelector(isLoggedInUserEngineer);
  if (!userIsEngineer) return null;

  return (
    <SceneMenuContent>
      <AddItemMenuItem type="gusset" />
    </SceneMenuContent>
  );
}
